import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.modals.remove.title',
    defaultMessage: 'Skill exclusion',
  },
  subtitle: {
    id: 'simulated.modals.remove.subtitle',
    defaultMessage: 'Are you sure you want to delete this skill?',
  },
  cancel: {
    id: 'simulated.modals.remove.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'simulated.modals.remove.continue',
    defaultMessage: 'Continue',
  },
  success: {
    id: 'simulated.modals.remove.success',
    defaultMessage: 'Skill excluded',
  },
  problem: {
    id: 'simulated.modals.remove.problem',
    defaultMessage: 'Could not delete skill',
  },
  feedback: {
    id: 'simulated.modals.remove.feedback',
    defaultMessage: 'The skill {ability} has been successfully deleted!',
  },
});
